import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
//api
import { getLogin } from '../../api/users'
import { getEntryPath } from 'utils/yupiUser'


function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async ({ userName, password }) => {
        try {
			console.log("Entrando a useAuth")
			const body={
				"email":userName,
				"password":password
			}
			const user = await getLogin(body)// apiSignIn({ userName, password })
			console.log("imprimiendo", user)
			if (user.data) {
				
					const { avatar, accountUserName, email, authority, _id: id } = user.data
					const resp={
						user: { avatar, accountUserName, email, authority,id },
						token: user.token,
						expiration:user.expiration
					}
					
				console.log(resp)
				const { token } = resp;
				dispatch(onSignInSuccess(token))
				if(resp.user) {
					dispatch(setUser(resp.user || { 
						avatar: '', 
						accountUserName: 'Anonymous', 
						authority: ['USER'], 
						email: ''
					}))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : getEntryPath(authority))
                return {
                    status: 'success',
                    message: ''
                }
			}else{
				return {
					status: 'failed',
					message: "Credenciales incorrectas"
				}
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}
    
    return {
        authenticated: token && signedIn,
        signIn,
        signOut
    }
}

export default useAuth